<template>
  <authentication-layout>
    <header slot="form-header" class="header">
      <img class="icon -colour" src="/src/assets/image/icon/mailer.svg" alt="Ícone de E-mail">
      <h2 class="title">Seu cadastro foi realizado com sucesso</h2>
      <p class="subtitle">Acesse seu e-mail <strong>{{`${userSignUp.email}`}}</strong>,
      e ative sua conta para realizar seus requerimentos de Licenças,
      Autorizações e outros Documentos Ambientais.</p>
    </header>

    <template slot="navigation">
      <v-btn flat small color="primary" class="link"
             :to="'/requerente/conta/entrar'">
        <v-icon left>mdi-account-circle</v-icon>
        <span class="text">Voltar ao login</span>
      </v-btn>
    </template>
  </authentication-layout>
</template>

<script>
import AuthenticationLayout from '@/layouts/AuthenticationLayout';

export default {
  name: 'SuccessSignup',
  components: {
    AuthenticationLayout,
  },
  computed: {
    userSignUp() {
      return this.$store.getters.userSignUp;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
